import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEnvironmentService } from '../services/settings/api-environment.service';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  private apiEnvironmentService = inject(ApiEnvironmentService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentApiUrl: string = this.apiEnvironmentService.getCurrentApiUrl();
    const defaultDevUrl: string = 'https://api.dev.sunnystreet.com';
    const defaultProdUrl: string = 'https://api.sunnystreet.com';
    
    if (request.url.includes(defaultDevUrl) || request.url.includes(defaultProdUrl)) {
      let newUrl: string = request.url;
      
      if (request.url.includes(defaultDevUrl)) {
        newUrl = request.url.replace(defaultDevUrl, currentApiUrl);
      } else if (request.url.includes(defaultProdUrl)) {
        newUrl = request.url.replace(defaultProdUrl, currentApiUrl);
      }
      
      const modifiedRequest: HttpRequest<unknown> = request.clone({
        url: newUrl
      });
      
      return next.handle(modifiedRequest);
    }
    
    return next.handle(request);
  }
}
